import { EMPTY_VALUE } from '../constants/styles';

/**
 * Знак влияния (lift) на целевой исход:
 * - `positive` — влияние выше базовой доли;
 * - `negative` — ниже базовой;
 * - `neutral` — около нуля либо неизвестно.
 */
export type LiftSign = 'positive' | 'negative' | 'neutral';

/**
 * Зона «около нуля» для lift (в долях): при |lift| меньше — влияние нейтрально.
 */
export const LIFT_EPSILON = 0.02;

/**
 * Классифицирует lift (доля) по знаку с учётом зоны нечувствительности {@link LIFT_EPSILON}.
 */
export const getLiftSign = (lift: number | null | undefined): LiftSign => {
  if (lift == null || Math.abs(lift) < LIFT_EPSILON) return 'neutral';
  return lift > 0 ? 'positive' : 'negative';
};

/**
 * CSS-класс цвета текста (design-токен) для влияния lift:
 * положительное — `text-primary`, отрицательное — `text-destructive`,
 * нейтральное/неизвестное — `text-muted-foreground`.
 */
export const liftColorClass = (lift: number | null | undefined): string => {
  const sign = getLiftSign(lift);
  if (sign === 'positive') return 'text-primary';
  if (sign === 'negative') return 'text-destructive';
  return 'text-muted-foreground';
};

/**
 * Форматирует lift (доля 0..1) как знаковые процентные пункты, напр. `+8.0` / `−3.5`.
 * Для null/undefined возвращает прочерк.
 */
export const formatLiftPp = (lift: number | null | undefined): string => {
  if (lift == null) return EMPTY_VALUE;
  const pp = lift * 100;
  return `${pp > 0 ? '+' : ''}${pp.toFixed(1)}`;
};
